import React from 'react';
import {Link} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiPlus} = FiIcons;

const Footer = () => {
  const cities = [
    'Los Angeles', 'San Diego', 'San Jose', 'San Francisco', 'Fresno',
    'Sacramento', 'Oakland', 'Long Beach', 'Anaheim', 'Santa Ana'
  ];

  const cityLinks = cities.map(city => {
    const citySlug = city.toLowerCase().replace(' ', '-');
    return {
      city,
      links: [
        {name: `${city} General Liability`, href: `/${citySlug}-general-liability`},
        {name: `${city} BOP`, href: `/${citySlug}-bop`},
        {name: `${city} Workers' Comp`, href: `/${citySlug}-workers-compensation`}
      ]
    };
  });

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            {/* Updated Logo Partnership Display */}
            <div className="flex items-center justify-center space-x-4 mb-6 p-4 bg-white rounded-lg">
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1757434525511-Screen%20Shot%202025-09-08%20at%2010.31.00%20PM.png"
                alt="Burbank Insurance Services Partnership with Next Insurance"
                className="h-16 w-auto object-contain"
              />
            </div>
            <p className="text-gray-300 mb-4">
              Your trusted partner for Next Insurance solutions in California.
            </p>
            <div className="space-y-2 text-sm text-gray-300">
              <p>Email: info@burbankinsuranceservices.com</p>
              <p>Phone: (818) 471-4255</p>
              <p className="text-xs text-gray-400 mt-3">CA License #6013543</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/business-owners-policy" className="text-gray-300 hover:text-white transition-colors">Business Owner's Policy</Link></li>
              <li><Link to="/workers-compensation" className="text-gray-300 hover:text-white transition-colors">Workers' Compensation</Link></li>
              <li><Link to="/general-liability" className="text-gray-300 hover:text-white transition-colors">General Liability</Link></li>
              <li><Link to="/commercial-auto" className="text-gray-300 hover:text-white transition-colors">Commercial Auto</Link></li>
              <li><Link to="/commercial-property" className="text-gray-300 hover:text-white transition-colors">Commercial Property</Link></li>
              <li><Link to="/cyber-liability" className="text-gray-300 hover:text-white transition-colors">Cyber Liability</Link></li>
              <li><Link to="/tools-equipment" className="text-gray-300 hover:text-white transition-colors">Tools & Equipment</Link></li>
              <li><Link to="/epli" className="text-gray-300 hover:text-white transition-colors">EPLI</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors">About</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* California Cities - First Half */}
          <div>
            <h3 className="text-lg font-semibold mb-4">California Cities</h3>
            <ul className="space-y-1 text-sm">
              {cityLinks.slice(0, 5).map(({city, links}) => (
                <li key={city}>
                  <div className="font-medium text-gray-200 mb-1">{city}</div>
                  <ul className="ml-2 space-y-1">
                    {links.map(link => (
                      <li key={link.href}>
                        <Link
                          to={link.href}
                          className="text-gray-400 hover:text-white transition-colors text-xs"
                        >
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </div>

          {/* California Cities - Second Half */}
          <div>
            <h3 className="text-lg font-semibold mb-4">&nbsp;</h3>
            <ul className="space-y-1 text-sm">
              {cityLinks.slice(5).map(({city, links}) => (
                <li key={city}>
                  <div className="font-medium text-gray-200 mb-1">{city}</div>
                  <ul className="ml-2 space-y-1">
                    {links.map(link => (
                      <li key={link.href}>
                        <Link
                          to={link.href}
                          className="text-gray-400 hover:text-white transition-colors text-xs"
                        >
                          {link.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Burbank Insurance Services. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;